import { Icon } from 'bold-ui'
import { TipoMedicaoEnum } from 'graphql/types.generated'

export type GrupoMedicoesTipoModel = {
  tipo: TipoMedicaoEnum
  medicoes: MedicaoProntuarioModel[]
}

export type MedicaoProntuarioModel = {
  key: ID
  dataMedicao?: Instant
  valor?: string
  observacao?: string
}

export type TipoMedicaoAtendimento = {
  label?: string
  unidadeMedida?: string
  order?: number
  icon?: React.ReactElement
  colorScale?: string
}

export const tipoMedicaoRecord: Record<TipoMedicaoEnum, TipoMedicaoAtendimento> = {
  [TipoMedicaoEnum.PESO]: {
    order: 1,
    label: 'Peso',
    unidadeMedida: 'kg',
    icon: <Icon icon='balanceFilled' />,
  },
  [TipoMedicaoEnum.ALTURA]: {
    order: 2,
    label: 'Altura',
    unidadeMedida: 'cm',
    icon: <Icon icon='rulerFilled' />,
  },
  [TipoMedicaoEnum.IMC]: {
    order: 3,
    label: 'IMC',
    unidadeMedida: 'kg/m²',
    icon: <Icon icon='imcFilled' />,
  },
  [TipoMedicaoEnum.PRESSAO_ARTERIAL]: {
    order: 4,
    label: 'Pressão arterial',
    unidadeMedida: 'mmHg',
    icon: <Icon icon='bloodPressureFilled' />,
  },
  [TipoMedicaoEnum.FREQUENCIA_RESPIRATORIA]: {
    order: 5,
    label: 'Freq. respiratória',
    unidadeMedida: 'mpm',
    icon: <Icon icon='lungs' />,
  },
  [TipoMedicaoEnum.FREQUENCIA_CARDIACA]: {
    order: 6,
    label: 'Freq. cardíaca',
    unidadeMedida: 'bpm',
    icon: <Icon icon='heartRateFilled' />,
  },
  [TipoMedicaoEnum.TEMPERATURA]: {
    order: 7,
    label: 'Temperatura',
    unidadeMedida: 'ºC',
    icon: <Icon icon='thermometerFilled' />,
  },
  [TipoMedicaoEnum.SATURACAO_O2]: {
    order: 8,
    label: 'Saturação de O2',
    unidadeMedida: '%',
    icon: <Icon icon='o2Filled' />,
  },
  [TipoMedicaoEnum.CIRCUNFERENCIA_ABDOMINAL]: {
    order: 9,
    label: 'Circ. abdominal',
    unidadeMedida: 'cm',
    icon: <Icon icon='abdominalMeasuresFilled' />,
  },
  [TipoMedicaoEnum.PERIMETRO_CEFALICO]: {
    order: 10,
    label: 'Per. cefálico',
    unidadeMedida: 'cm',
    icon: <Icon icon='headMeasuresFilled' />,
  },
  [TipoMedicaoEnum.PERIMETRO_PANTURRILHA]: {
    order: 11,
    label: 'Per. da panturrilha',
    unidadeMedida: 'cm',
    icon: <Icon icon='calfMeasuaresFilled' />,
  },
  [TipoMedicaoEnum.GLICEMIA]: {
    order: 12,
    label: 'Glicemia capilar',
    unidadeMedida: 'mg/dL',
    icon: <Icon icon='glucometer' />,
  },
  [TipoMedicaoEnum.DUM]: {}, // Essa informação ainda não é apresentada na lateral do atendimento
  [TipoMedicaoEnum.ALTURA_UTERINA]: {}, // Essa informação ainda não é apresentada na lateral do atendimento
}
